import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/**
 *
 * @param id: The identifier of the panel. Must be unique within the `ExpandCollapse` panels.
 * @param children: The content. Can be text, any HTML element, or any component.
 * @param style: Add custom inline styles.
 * @param className: Add custom css classes.
 * @returns
 */
var Panel = function (_a) {
    var children = _a.children, id = _a.id;
    return (_jsx(_Fragment, { children: _jsx("div", { id: "panel-".concat(id), "data-testid": "panel-".concat(id), children: children }) }));
};
export default Panel;
